import React, {useContext, useEffect, useState} from "react";
import SideNav from "../components/SideNav";
import {useHistory} from "react-router-dom";
import {AppContext} from "../App";
import {AppService} from "../services/app.service";
import {BASE_URL} from "../env.json";
import TopNavBar from "../components/TopNavBar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrophy} from "@fortawesome/pro-light-svg-icons";
import Accordion from "../components/Accordion";
import {IconButton, Snackbar} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {IconProp} from "@fortawesome/fontawesome-svg-core";

function TasksList(){
    const [percentage, setPercentage] = useState<number>(0);
    const context = useContext(AppContext);
    let tasks = context.activeWeekTaskList.tasks;
    let weekTitle = context.activeWeekTaskList.title;
    let lessonItems: any = [];
    let history = useHistory();
    const [userWeekNo, setUserWeekNo] = useState<number>(0);
    const [userTaskNo, setUserTaskNo] = useState<number>(0);

    const [alertMsg, setAlertMsg] = useState<string>("")
    const [open, setOpen] = useState<boolean>(false)
    const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const Hero  = () => {
        return (
            <div className={'hero'}>
                <div className={'label'}>WEEK {context.currentWeekNo}</div>
                <div className={'achievement'}>
                    <div className={'left-line'}/>
                    <FontAwesomeIcon icon={faTrophy as IconProp} className={'trophy'}/>
                    <div className={'right-line'}/>
                </div>
                <div className={'heading'}>
                    {weekTitle}
                </div>
            </div>
        )
    }

    const TaskProgress = () => {
        return(
            <div className={'progress-container'}>
                <div className={'progress'}>
                    <div className={'rail'}/>
                    <div className={'label'}>{percentage}% COMPLETE</div>
                    <div className={'track'} id={'progress-percentage'}>
                        <div className={'label-white'}>
                            {percentage}% COMPLETE
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    function isItemCompleted(taskNo: Number){
        if(context.isCompleted){
            return true;
        }
        if(userWeekNo > Number(context.currentWeekNo)) {
            return true;
        } else if(userTaskNo > taskNo){
            return true;
        } else {
            return false;
        }
    }

    const getTotalProgress = (taskItems: any) => {
        if(taskItems) {
            // console.log('ITEMS', taskItems);
            const taskCount = Object.keys(taskItems).length
            let completedCount: number = 0;
            taskItems.forEach((item:any) => {
                if(isItemCompleted(item.ordering_number)) {
                    completedCount++;
                }
            });
            let _percent: number = completedCount / taskCount;
            let _total_progress: number = _percent * 100;
            // console.log('Progress Level ', _total_progress);
            return _total_progress
        } else {
            return 0;
        }
    }

    const getTotalDuration = (taskItems: any) => {
        if(taskItems) {
            let _totalDuration: number = 0;
            taskItems.forEach((item:any) => {
                _totalDuration += item.estimated_duration;
            });
            return _totalDuration
        } else {
            return 0;
        }
    }

    if(tasks){
        const maxLesson = tasks.reduce((op: number, item: any) => op = op > item.lesson_no ? op : item.lesson_no, 0);
        for(let i=0; i < maxLesson; i++) {
            let lessonNumber = i + 1
            const tasksOfThatLesson: any = tasks.filter((obj:any) => {
                return obj.lesson_no === lessonNumber;
            })
            let progressCompleted: number = getTotalProgress(tasksOfThatLesson);
            let totalDuration: number = getTotalDuration(tasksOfThatLesson);
            lessonItems.push(
                <Accordion key={i}
                         lessonNo={lessonNumber}
                         durationInMinutes={totalDuration}
                         tasks={tasksOfThatLesson}
                         currentTask={userTaskNo}
                         currentWeek={userWeekNo}
                         progress={progressCompleted}
                         onClickWhileLocked={() => {
                             setAlertMsg("This task is currently Locked.")
                             setOpen(true);
                         }}
                />
            );
        }
    }

    useEffect(()=> {
        async function getUserData(){
            let appService = new AppService();
            const userData = await appService.fetchData(BASE_URL + `recovery2/recovery2-user/${context.recoveryId}/`);

            if(userData !== undefined) {
                setUserWeekNo(Number(userData.data.current_task.week.ordering_number));
                setUserTaskNo(Number(userData.data.current_task.ordering_number));

                let userWeekNo: number = Number(userData.data.current_task.week.ordering_number);
                let userTaskNo: number = Number(userData.data.current_task.ordering_number) - 1;

                // compute base on client state
                if(userWeekNo > Number(context.currentWeekNo)){
                    setPercentage(100);
                } else  {
                    // activeWeekTaskList is a context data and dissolve when the app exits
                    // so redirect back to main menu when it is empty
                    if(context.activeWeekTaskList.tasks !== undefined){
                        let totalActiveTaskCount = context.activeWeekTaskList.tasks.length;
                        let percentage = (userTaskNo/totalActiveTaskCount) * 100;
                        setPercentage(Math.trunc(percentage));
                    }
                    else {
                        history.push(`/home/${context.deviceId}/${context.recoveryId}`);
                    }

                }
            }
        }
        getUserData();
    }, []);

    useEffect(()=> {
        function refreshProgress(){
            let percent: any = document.getElementById('progress-percentage')
            percent.style.width = `${percentage}%`;
        }
       refreshProgress();
    });

    return(
        <div className={'container'}>
            <SideNav/>
            <div className={'app-page'}>
                <div className={'task-list'}>
                    <TopNavBar weekNo={Number(context.currentWeekNo)}/>
                    <Hero/>
                    <TaskProgress/>
                    <div className={'task-container'}>
                        {lessonItems}
                    </div>
                </div>
                {/*<BottomNav/>*/}
            </div>

            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
                message={alertMsg}
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />

        </div>
    )
}
export default TasksList;